(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vowmira-remote-image-qa"] && !Shopify.designMode) return;
  try {
    (() => {
    const removeRemoteCards = (root) => {
      if (!(root instanceof Element || root instanceof Document)) return;
      const links = [];
      if (root instanceof HTMLAnchorElement && root.matches('a[href*="/products/"][href*="-remote"]')) links.push(root);
      root.querySelectorAll('a[href*="/products/"][href*="-remote"]').forEach((link) => links.push(link));
      links.forEach((link) => {
        const container = link.closest('li.grid__item, li, [data-product-card], article') || link.closest('.card-wrapper');
        if (container) container.remove();
        else link.remove();
      });
    };

    removeRemoteCards(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => removeRemoteCards(node));
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
